const getLanguageFromExtension = (filePath) => {
    const ext = filePath.split(".").pop().toLowerCase();
    switch (ext) {
        case "js":
        case "jsx":
            return "javascript";
        case "ts":
        case "tsx":
            return "typescript";
        case "py":
            return "python";
        case "html":
            return "html";
        case "css":
            return "css";
        case "json":
            return "json";
        case "java":
            return "java";
        case "c":
            return "c";
        case "cpp":
            return "cpp";
        case "cs":
            return "csharp";
        case "rb":
            return "ruby";
        case "php":
            return "php";
        case "go":
            return "go";
        default:
            return "plaintext";
    }
};

export default getLanguageFromExtension